<template>
  <div class="w-full flex items-center justify-start mb-16">
    <button
        @click="copy(userInfo.value)"
        class="field w-full flex flex-col items-center justify-center rounded bg-zt-white primary-200 pr relative px-3 text-zt-dark-300"
    >
      <div class="flex items-center">
        <zt-icon name="copy-file" class="mr-2 text-zt-xl" />
        <span class="font-medium">
          {{ $t("message.selfService.taskManager.field.copy") }}
        </span>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'UserCopyValue',
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async copy(value) {
      await navigator.clipboard.writeText(value)
    }
  }
}
</script>

<style scoped lang="scss">
.image-icon {
  width: 80px;
  height: 60px;
}
.field {
  height: 50px;
  border: 1px solid #969696!important;
  .fake-label {
    top: -10px;
    font-size: 0.85rem;
    padding: 1px 5px 0;
  }
  .caret-icon {
    top: 18px;
    right: 15px;
  }
}
.field-auto {
  height: auto!important;
}
.primary-200 {
  color: #4F41A3!important;
  border-color: #4F41A3!important;
}
</style>